import React from 'react';

import VoidedProgressDot from '@/assets/icons/voided-progress-dot';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { common, designSystem } from '@/styles/styles';

export const DotStatus = {
    Open: 'open',
    Won: 'won',
    Lost: 'lost',
    Voided: 'voided',
    Revived: 'revived',
} as const;

export type DotStatus = (typeof DotStatus)[keyof typeof DotStatus];

const backgroundColors = {
    [DotStatus.Open]: ds.colorToken.background.neutral.subtle,
    [DotStatus.Won]: ds.colorToken.background.success.strong,
    [DotStatus.Lost]: ds.colorToken.background.danger.strong,
    [DotStatus.Revived]: ds.colorToken.background.accent.blue.strong,
} as const;

const ProgressDot = ({ dot }: { dot: DotStatus }) => {
    if (dot === DotStatus.Voided) {
        return <VoidedProgressDot fill={designSystem.colors.neutral300} />;
    }
    const backgroundColor = backgroundColors[dot];
    return <Box width={8} height={8} borderRadius="r96" backgroundColor={backgroundColor} style={common.borderCurve} />;
};

export const ProgressDots = ({ dots }: { dots: Array<DotStatus> }) => {
    return (
        <Row columnGap="s4">
            {dots.map((dot, index) => (
                <ProgressDot key={`${dot}-${index}`} dot={dot} />
            ))}
        </Row>
    );
};
